import { ShaderMaterial } from 'three';

class BaseShaderMaterial extends ShaderMaterial {
  constructor(vertexShader, fragmentShader, uniforms = {}) {
    // Wrap raw values into {value:} format if not already
    const processedUniforms = {};
    for (const key in uniforms) {
      processedUniforms[key] = uniforms[key];
    }

    super({
      vertexShader,
      fragmentShader,
      uniforms: processedUniforms,
    });
  }
}

export { BaseShaderMaterial };
